var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { attrs: { id: "more-like-this" } },
    [
      _c(
        "h2",
        {
          staticClass: "h3",
          staticStyle: { "--margin-bottom": "var(--spacing-md)" },
        },
        [_vm._v("\n    More icons like " + _vm._s(_vm.icon.name) + "…\n  ")]
      ),
      _vm._v(" "),
      _c(
        "ais-instant-search",
        {
          ref: "instantSearch",
          attrs: {
            "search-client": _vm.searchClient,
            "index-name": _vm.index,
            "insights-client": _vm.insightsClient,
            middlewares: _vm.middlewares,
            "search-parameters": { clickAnalytics: true },
          },
        },
        [
          _c("ais-configure", {
            attrs: {
              hitsPerPage: 180,
              distinct: true,
              facetFilters: _vm.facetFilters(),
            },
          }),
          _vm._v(" "),
          _c("ais-hits", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ items }) {
                  return _c(
                    "div",
                    {
                      class: `icon-listing ${_vm.resultsView}`,
                      attrs: { id: "icons-listing" },
                    },
                    _vm._l(items, function (item) {
                      return _c("icon-link", {
                        key: item.objectID,
                        attrs: {
                          icon: item,
                          "results-view": _vm.resultsView,
                          version: _vm.version,
                        },
                      })
                    }),
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }